import { render, staticRenderFns } from "./orderDetail1.vue?vue&type=template&id=f0351cae"
import script from "./orderDetail1.vue?vue&type=script&lang=js"
export * from "./orderDetail1.vue?vue&type=script&lang=js"
import style0 from "./orderDetail1.vue?vue&type=style&index=0&id=f0351cae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports